/* ============================================
   THE ENCHANTED PATH — Quill Writing Effect v2
   
   WHERE TO PUT THIS:
   In layout/theme.liquid, paste inside
   <script>...</script> tags before </body>
   OR add as a separate .js asset file:
   <script src="{{ 'enchanted-quill.js' | asset_url }}" defer></script>
   ============================================ */

(function () {
  'use strict';

  var contactForm = document.querySelector('.contact');
  if (!contactForm) return;

  var QUILL_FRAMES = [
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/quillleft.png?v=1772818235',
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/quillcenter.png?v=1772818235',
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/quillright.png?v=1772818235'
  ];

  // Preload
  QUILL_FRAMES.forEach(function (src) {
    var img = new Image();
    img.src = src;
  });

  // Create quill element
  var quill = document.createElement('img');
  quill.src = QUILL_FRAMES[0];
  quill.className = 'enchanted-quill';
  quill.alt = '';
  document.body.appendChild(quill);

  // Inject quill styles
  var style = document.createElement('style');
  style.textContent =
    '.enchanted-quill {' +
    '  position: absolute;' +
    '  width: 50px;' +
    '  height: auto;' +
    '  pointer-events: none;' +
    '  z-index: 9999;' +
    '  opacity: 0;' +
    '  transition: opacity 0.3s ease, left 0.12s ease, top 0.12s ease;' +
    '  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));' +
    '}' +
    '.enchanted-quill.visible {' +
    '  opacity: 1;' +
    '}' +
    '.enchanted-quill.writing {' +
    '  animation: quill-bob 0.15s ease;' +
    '}' +
    '@keyframes quill-bob {' +
    '  0%   { transform: rotate(0deg); }' +
    '  30%  { transform: rotate(-1.5deg) translateY(-1px); }' +
    '  60%  { transform: rotate(1deg); }' +
    '  100% { transform: rotate(0deg); }' +
    '}';
  document.head.appendChild(style);

  var frameIndex = 0;
  var activeField = null;
  var hideTimeout = null;

  // ── Quill offset config ──
  // Adjust these to move the quill nib position:
  //   OFFSET_X: pixels to the right of the text cursor (negative = left)
  //   OFFSET_Y: pixels above the text baseline (negative = up, positive = down)
  var OFFSET_X = 0;
  var OFFSET_Y = -75;

  function getCursorPosition(field) {
    var rect = field.getBoundingClientRect();
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Create hidden measurer
    var measurer = document.createElement('span');
    var cs = getComputedStyle(field);
    measurer.style.cssText =
      'position:absolute;visibility:hidden;white-space:pre;' +
      'font-family:' + cs.fontFamily + ';' +
      'font-size:' + cs.fontSize + ';' +
      'font-weight:' + cs.fontWeight + ';' +
      'letter-spacing:' + cs.letterSpacing + ';';

    var cursorPos = field.selectionStart || field.value.length;
    var textBeforeCursor = field.value.substring(0, cursorPos);

    var paddingLeft = parseFloat(cs.paddingLeft) || 0;
    var paddingTop = parseFloat(cs.paddingTop) || 0;

    if (field.tagName === 'TEXTAREA') {
      var lines = textBeforeCursor.split('\n');
      var currentLine = lines[lines.length - 1];
      measurer.textContent = currentLine || '';

      document.body.appendChild(measurer);
      var textWidth = measurer.offsetWidth;
      document.body.removeChild(measurer);

      var lineHeight = parseFloat(cs.lineHeight) || 29;
      var currentLineIndex = lines.length - 1;

      return {
        x: rect.left + scrollLeft + paddingLeft + textWidth + OFFSET_X,
        y: rect.top + scrollTop + paddingTop + (currentLineIndex * lineHeight) + OFFSET_Y
      };
    } else {
      measurer.textContent = textBeforeCursor || '';

      document.body.appendChild(measurer);
      var textWidth = measurer.offsetWidth;
      document.body.removeChild(measurer);

      return {
        x: rect.left + scrollLeft + paddingLeft + textWidth + OFFSET_X,
        y: rect.top + scrollTop + OFFSET_Y
      };
    }
  }

  function positionQuill(field) {
    var pos = getCursorPosition(field);

    // Clamp to postcard bounds
    var formRect = contactForm.getBoundingClientRect();
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var maxX = formRect.right + scrollLeft - 30;
    var minX = formRect.left + scrollLeft;

    quill.style.left = Math.max(minX, Math.min(pos.x, maxX)) + 'px';
    quill.style.top = pos.y + 'px';
  }

  function animateQuill() {
    frameIndex = (frameIndex + 1) % QUILL_FRAMES.length;
    quill.src = QUILL_FRAMES[frameIndex];

    quill.classList.remove('writing');
    void quill.offsetWidth;
    quill.classList.add('writing');
  }

  // Attach to all contact form fields
  var fields = contactForm.querySelectorAll('input, textarea');

  fields.forEach(function (field) {
    field.addEventListener('focus', function () {
      activeField = field;
      if (hideTimeout) clearTimeout(hideTimeout);

      setTimeout(function () {
        positionQuill(field);
        quill.classList.add('visible');
      }, 150);
    });

    field.addEventListener('blur', function () {
      hideTimeout = setTimeout(function () {
        quill.classList.remove('visible');
        activeField = null;
      }, 500);
    });

    field.addEventListener('input', function () {
      if (activeField !== field) return;
      animateQuill();
      positionQuill(field);
    });

    field.addEventListener('click', function () {
      if (activeField === field) {
        positionQuill(field);
      }
    });

    field.addEventListener('keyup', function (e) {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(e.key) !== -1) {
        positionQuill(field);
      }
    });
  });

  window.addEventListener('scroll', function () {
    if (activeField) positionQuill(activeField);
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (activeField) positionQuill(activeField);
  });

})();